import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  highlightedText: {
    color: theme.palette.grapePurple,
  },
}))

export default styles
